//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import subNavSelection from "~/components/header-item-selection";
import BannerTypeProduct from "~/components/content-elements/banner-type-product";
import dilmah_map from "~/components/content-elements/dilmah-map.vue";
export default {
  data() {
    return {
      icon: "/images/map-pin-icon2.png",
      iconSize: [30, 30],
      activeIndex: 0,
      center: {
        lat: "",
        long: "",
      },
    };
  },
  mounted() {
    this.$store.dispatch("tea-products/getTeaMakersPrivateReserve");
  },
  components: {
    dilmah_map,
    BannerTypeProduct,
    subNavSelection,
  },
  methods: {},
  computed: {
    pageData() {
      return this.$store.state["tea-products"].teaMakersPrivateReserve;
    },
  },

  watch: {
    pageData(val) {
      this.center = {
        lat: val.tea_locations.tea_locations[0].latitude,
        long: val.tea_locations.tea_locations[0].longitude,
      };
      this.$nuxt.$loading.finish();
    },
  },
};
